import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '.';
import { AuthPayload } from '@/utils/types';


export const authApi = createApi({
    reducerPath: 'authApi',
    tagTypes: ['user'],
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        login: builder.mutation({
            query: ({ target, ...body }: AuthPayload) => ({
                url: `auth/${target}/login`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['user'],
        }),

        getProfile: builder.query({
            query: ({ target }: { target: string }) => ({
                url: `auth/${target}/profile`,
                method: 'GET',
            }),
        }),
        logout: builder.mutation({
            query: ({ target }: { target: string }) => ({
                url: `auth/${target}/logout`,
                method: 'POST',
            }),
            invalidatesTags: ['user'],
        }),
    }),
});

export const { useLoginMutation, useLogoutMutation,  useLazyGetProfileQuery } = authApi;
